import PropTypes from 'prop-types';
import colors from '../../util/colors.js';

/**
 * @deprecated
 * We no longer use enums for props (so that we don't force the user to import the enum).
 * This enum will remain here for backwards compatibility purposes.
 */
var AvatarSizes;
(function (AvatarSizes) {
    AvatarSizes["S"] = "s";
    AvatarSizes["M"] = "m";
    AvatarSizes["L"] = "l";
    AvatarSizes["XL"] = "xl";
})(AvatarSizes || (AvatarSizes = {}));
/**
 * @deprecated
 * We no longer use enums for props (so that we don't force the user to import the enum).
 * This enum will remain here for backwards compatibility purposes.
 */
var AvatarStatus;
(function (AvatarStatus) {
    AvatarStatus["ACTIVE"] = "active";
    AvatarStatus["INACTIVE"] = "inactive";
    AvatarStatus["PENDING"] = "pending";
    AvatarStatus["DANGER"] = "danger";
})(AvatarStatus || (AvatarStatus = {}));
var defaultProps = {
    avatarColor: colors.gray10,
    size: 'm',
    selected: false,
    // by default, the `alt` attribute should be an empty string, because the image is purely decorative
    alt: '',
    'data-testid': 'spoton-avatar',
};
var propTypes = {
    initials: PropTypes.string,
    photoUrl: PropTypes.string,
    avatarColor: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    alt: PropTypes.string,
    status: PropTypes.oneOf([
        'active',
        'inactive',
        'pending',
        'danger',
        'busy',
    ]),
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']).isRequired,
    selected: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    'data-testid': PropTypes.string,
};

export { AvatarSizes, AvatarStatus, defaultProps, propTypes };
